import React from 'react';

export const footerDropContext = React.createContext<(ref: Element | null) => void>(() => {});
export const FooterDropContextProvider = footerDropContext.Provider;

export const headerDropContext = React.createContext<(ref: Element | null) => void>(() => {});
export const HeaderDropContextProvider = headerDropContext.Provider;

export const rowHandleRefContext = React.createContext<(ref: Element | null) => void>(() => {});
export const RowHandleRefContextProvider = rowHandleRefContext.Provider;
